
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5Zpln", function(module, exports) {
/* ArchiveConfirmationMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $xQxzY = parcelRequire("xQxzY");


var $3pgvV = parcelRequire("3pgvV");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7gpC4 = parcelRequire("7gpC4");


var $inPa6 = parcelRequire("inPa6");


var $b3j2Y = parcelRequire("b3j2Y");


var $12UWa = parcelRequire("12UWa");

/* ArchiveNestedPagesPermissionWarning.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
















var $8C5kA = parcelRequire("8C5kA");





var $2Nwuj = parcelRequire("2Nwuj");





var $aoVih = parcelRequire("aoVih");


var $9wGTI = parcelRequire("9wGTI");








var $aqBZ0 = parcelRequire("aqBZ0");

const $81c5fd94c923765e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    archiveContentLimitedPermissionWarningTitleV2: {
        id: "archive-pages.content-nested.archive.limited-permission.title.V2",
        defaultMessage: "Some items can\u2019t be archived"
    },
    archiveContentLimitedPermissionWarningMessageV2: {
        id: "archive-pages.content-nested.archive.limited-permission.message.V2",
        defaultMessage: "{count, plural, one {You don't have permission to archive # item. If you archive \"{contentName},\" that item will move up one level in the content tree.} other {You don't have permission to archive # items. If you archive \"{contentName},\" those items will move up one level in the content tree.}} <a>Why can't I archive nested items?</a>"
    },
    archiveContentSelectionLimitReachedWarningMessageV2: {
        id: "archive-pages.content-nested.archive.selection-limit-reached.message.v2",
        defaultMessage: "Only 500 items can move at a time. Select a smaller branch to archive the parent and nested items together."
    },
    archiveContentCannotArchiveNestedItemsTitle: {
        id: "archive-pages.content-nested.archive.cannot-archive-nested-items.title",
        defaultMessage: "Nested items won\u2019t be archived"
    },
    archiveContentCannotArchiveNestedItemsMessage: {
        id: "archive-pages.content-nested.archive.cannot-archive-nested-items.message",
        defaultMessage: "You don\u2019t have permission to archive all of the nested items. They\u2019ll move up in the content tree. <a>Why can\u2019t I archive nested items?</a>"
    },
    archivePermissionsInfoLinkAriaDescription: {
        id: "archive-pages.dialog.archive.inherited-restrictions.info.link.aria-description",
        defaultMessage: "archive permissions - link opens in a new tab"
    },
    unarchiveContentNoPermissionWarningTitleV2: {
        id: "archive-pages.content-nested.unarchive.cannot-restore-nested-items.title",
        defaultMessage: "Nested items won\u2019t be restored"
    },
    unarchiveContentNoPermissionWarningMessageV2: {
        id: "archive-pages.content-nested.unarchive.cannot-restore-nested-items.message",
        defaultMessage: "You don\u2019t have permission to restore all of the nested items. They\u2019ll move up in the archive. <a>Why can\u2019t I restore nested items?</a>"
    },
    unarchiveContentLimitedPermissionWarningTitleV2: {
        id: "archive-pages.content-nested.unarchive.limited-permission.title.V2",
        defaultMessage: "{count, plural, one {1 nested item won\u2019t be restored} other {{count} nested items won\u2019t be restored}}"
    },
    unarchiveContentLimitedPermissionWarningMessageV2: {
        id: "archive-pages.content-nested.unarchive.limited-permission.message.V2",
        defaultMessage: "You don\u2019t have permission to restore some nested items. They\u2019ll move up in the archive. <a>Why can\u2019t I restore nested items?</a>"
    },
    unarchiveContentSelectionLimitWarningTitleV2: {
        id: "archive-pages.content-nested.unarchive.selection-limit-reached.title.V2",
        defaultMessage: "Nested items won\u2019t be restored"
    },
    unarchiveContentSelectionLimitWarningMessageV2: {
        id: "archive-pages.content-nested.unarchive.selection-limit-reached.message.V2",
        defaultMessage: "Only 500 items can move at a time. Select a smaller branch to restore the parent and nested items together."
    },
    unarchivePermissionsWarningLinkAriaDescription: {
        id: "archive-pages.content-nested.unarchive.limited-permission.message.link.aria-description",
        defaultMessage: "restoring archived items - link opens in a new tab"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81c5fd94c923765e$var$SectionMessageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $81c5fd94c923765e$export$4e740b2872facc4d = ({ contentId: contentId, isArchive: isArchive, isSelectionLimitReached: isSelectionLimitReached })=>{
    const firedScreenEventRef = (0, $42omo.useRef)(false);
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ArchiveNestedPagesPermissionWarningQuery($contentId:ID!){singleContent(id:$contentId){id title archivableDescendantsCount visibleDescendantsCount}}`, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-and-network'
    });
    const viewPermissionsSupportLink = {
        a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__admin-experien') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                "aria-label": intl.formatMessage($81c5fd94c923765e$export$a7357cdd1f0b0168.archivePermissionsInfoLinkAriaDescription),
                target: "_blank",
                href: (0, $aqBZ0.ARCHIVE_PERMISSIONS_SUPPORT_LINK)
            }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                "aria-label": intl.formatMessage($81c5fd94c923765e$export$a7357cdd1f0b0168.archivePermissionsInfoLinkAriaDescription),
                target: "_blank",
                href: (0, $aqBZ0.ARCHIVE_PERMISSIONS_SUPPORT_LINK)
            }, chunks)
    };
    const viewRestoreItemsSupportLink = {
        a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__admin-experien') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                "aria-label": intl.formatMessage($81c5fd94c923765e$export$a7357cdd1f0b0168.unarchivePermissionsWarningLinkAriaDescription),
                target: "_blank",
                href: (0, $aqBZ0.UNARCHIVE_PERMISSIONS_SUPPORT_LINK)
            }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                "aria-label": intl.formatMessage($81c5fd94c923765e$export$a7357cdd1f0b0168.unarchivePermissionsWarningLinkAriaDescription),
                target: "_blank",
                href: (0, $aqBZ0.UNARCHIVE_PERMISSIONS_SUPPORT_LINK)
            }, chunks)
    }; // Using "!data" instead of "loading" with "cache-and-network", as "load" can be true when cached
    // data is available and cause flickering due to reallocating subcomponents
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data) return null;
    const countArchivableNestedPages = data?.singleContent?.archivableDescendantsCount ?? null;
    const countNestedPages = data?.singleContent?.visibleDescendantsCount ?? null;
    const contentName = data?.singleContent?.title;
    const countNonArchivableNestedPages = Number(countNestedPages) - Number(countArchivableNestedPages); // return null if countArchivableNestedPages or countNestedPages is not a number or user is able to archive / restore all of nested pages
    if (((0, (/*@__PURE__*/$parcel$interopDefault($3pgvV)))(countArchivableNestedPages) || (0, (/*@__PURE__*/$parcel$interopDefault($3pgvV)))(countNestedPages) || countArchivableNestedPages >= countNestedPages) && !isSelectionLimitReached) return null;
     // At this point we are about to render some non-null content.  If we haven't fired the Screen
    // event, do so now.  Note that we can't use the standard "useEffect()"-based pattern to fire
    // an event on first render because the render is always being called even if it is not actually
    // showing anything on the page (that is, returning null).  We want the Screen event to be fired
    // the first time this component is actually visible.
    if (!firedScreenEventRef.current) {
        (0, $12UWa.fireScreenEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            name: `${(0, $12UWa.getActionName)(isArchive)}NestedPagesPermissionWarning`
        });
        firedScreenEventRef.current = true;
    }
    const archiveSelectionLimitReachedMessages = {
        mainTitle: $81c5fd94c923765e$export$a7357cdd1f0b0168.archiveContentCannotArchiveNestedItemsTitle,
        mainMsg: $81c5fd94c923765e$export$a7357cdd1f0b0168.archiveContentSelectionLimitReachedWarningMessageV2
    };
    const archiveNoPermissionMessages = {
        mainTitle: $81c5fd94c923765e$export$a7357cdd1f0b0168.archiveContentCannotArchiveNestedItemsTitle,
        mainMsg: $81c5fd94c923765e$export$a7357cdd1f0b0168.archiveContentCannotArchiveNestedItemsMessage
    };
    const archiveLimitedPermissionMessages = {
        mainTitle: $81c5fd94c923765e$export$a7357cdd1f0b0168.archiveContentLimitedPermissionWarningTitleV2,
        mainMsg: $81c5fd94c923765e$export$a7357cdd1f0b0168.archiveContentLimitedPermissionWarningMessageV2
    };
    const unarchiveNoPermissionMessages = {
        mainTitle: $81c5fd94c923765e$export$a7357cdd1f0b0168.unarchiveContentNoPermissionWarningTitleV2,
        mainMsg: $81c5fd94c923765e$export$a7357cdd1f0b0168.unarchiveContentNoPermissionWarningMessageV2
    };
    const unarchiveLimitedPermissionMessages = {
        mainTitle: $81c5fd94c923765e$export$a7357cdd1f0b0168.unarchiveContentLimitedPermissionWarningTitleV2,
        mainMsg: $81c5fd94c923765e$export$a7357cdd1f0b0168.unarchiveContentLimitedPermissionWarningMessageV2
    };
    const unarchiveSelectionLimitReachedMessages = {
        mainTitle: $81c5fd94c923765e$export$a7357cdd1f0b0168.unarchiveContentSelectionLimitWarningTitleV2,
        mainMsg: $81c5fd94c923765e$export$a7357cdd1f0b0168.unarchiveContentSelectionLimitWarningMessageV2
    };
    let i18nMessages;
    let count;
    if (isSelectionLimitReached) {
        i18nMessages = isArchive ? archiveSelectionLimitReachedMessages : unarchiveSelectionLimitReachedMessages;
        count = (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT);
    } else {
        // If we made it here, we know there is *at least one* nested page for which user lacks permission, out of
        // 1 or more total nested pages. We know this because the countArchivableNestedPages >= countNestedPages condition,
        // e.g. when user has permission for all nested pages, returns null earlier in the file.
        // So we could have....
        //    (a) one or more nested pages with no permission to archive ANY of them (that is, countArchivableNestedPages = 0
        //        and countNestedPages >= 1), or
        //    (b) multiple nested pages with some having permission and some not (that is, countArchivableNestedPages >= 1):
        //        We have at least 1 nested page where user HAS permission, and we already know at this point that the
        //        user also LACKS permission for at least 1 page, so we must have >=2 nested pages total and
        //        it is a mixed permissions scenario
        if (countArchivableNestedPages === 0) // No permission to archive/restore any of the nested pages
        i18nMessages = isArchive ? archiveNoPermissionMessages : unarchiveNoPermissionMessages;
        else // Permission to archive/restore some - but not all - of the nested pages
        i18nMessages = isArchive ? archiveLimitedPermissionMessages : unarchiveLimitedPermissionMessages;
        count = countArchivableNestedPages;
    }
    const title = i18nMessages.mainTitle ? {
        title: intl.formatMessage(i18nMessages.mainTitle, {
            count: count,
            countNonArchivableNestedPages: countNonArchivableNestedPages
        })
    } : {}; // Returns an updated support link if the user is restoring. If not, returns the existing support
    // link for archive permissions
    const supportLinkValue = !isArchive ? viewRestoreItemsSupportLink : viewPermissionsSupportLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($81c5fd94c923765e$var$SectionMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning",
        ...title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "archive-pages-permissions-warning-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...i18nMessages.mainMsg,
        values: {
            count: count,
            contentName: contentName,
            ...supportLinkValue
        }
    })))), i18nMessages.infoMsg1 && i18nMessages.infoMsg2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($81c5fd94c923765e$var$SectionMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), i18nMessages.infoMsg1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), i18nMessages.infoMsg2))) : null);
};



var $i9XHg = parcelRequire("i9XHg");


var $iJ15L = parcelRequire("iJ15L");




/* PageTreeWithArchivePermissions.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 






















var $3sFtD = parcelRequire("3sFtD");


var $7yDmn = parcelRequire("7yDmn");


var $ebrpi = parcelRequire("ebrpi");


var $9hlns = parcelRequire("9hlns");


var $bhDw8 = parcelRequire("bhDw8");

var $dlke8 = parcelRequire("dlke8");

var $CdIqF = parcelRequire("CdIqF");

var $e7vmR = parcelRequire("e7vmR");

var $60KKo = parcelRequire("60KKo");

var $39F3L = parcelRequire("39F3L");

var $h6CV4 = parcelRequire("h6CV4");


var $3gadb = parcelRequire("3gadb");


var $ubeQ2 = parcelRequire("ubeQ2");


var $4B2M3 = parcelRequire("4B2M3");


var $jlIaF = parcelRequire("jlIaF");


var $jmjWc = parcelRequire("jmjWc");


const $8d01b0a3f79209a8$export$1af6e64869692b36 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y1gm2",
    name: "NoChildrenBullet",
    loader: async ()=>(await (parcelRequire("iwOJa"))).NoChildrenBullet
});



var $kpLJY = parcelRequire("kpLJY");







//    We use view height to make a rough guesstimate for max height because the Atlaskit modal component,
//    which will be the parent of this component, dynamically resizes modal height to fit content until
//    it reaches a certain number of px away from the edge of the viewport. We want to take advantage of
//    this by letting the entire table + modal expand in height until it reaches a certain point,
//    after which the table should start internal scrolling.
// 2. For the row hover state,
//    we must wrap all table rows in a single parent container to apply row-specific
//    style overrides, because of limitations with rendering in AK table tree.
//    The best we can do to isolate each row element where styles should apply,
//    since Rows/Row do not accept classname prop, is the [role] attribute.
//    Also, only way to target the spinner rows, which somehow don't get put into a
//    div[role="row"], is to target the first child role["treegrid"]
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10f253e05dc6783a$var$TableTreeContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18m915zi _1reo15vq _c71l17as _1n4m1r31 _z8ec8stv _vdy6nqa1 _1wtl1fxt _1vhrglyw _y3au1jfw _fmyi12x7 _gh6gglyw _i6ibdkaa _tjxc12b0 _87eynqa1 _1gek1p6i _wtevlb4i _obos166n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10f253e05dc6783a$var$StyledTableHeaders = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz131l _mxbpze3t _1mhsxy5q _1rys1ejb _32f0esu3",
            __cmplp.className
        ])
    });
}); // right-align the permissions icons in table
const $10f253e05dc6783a$var$PermissionCell = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $bhDw8.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21sbv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10f253e05dc6783a$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s85ogf _1yt41w01 _1bsbidpf",
            __cmplp.className
        ])
    });
});
const $10f253e05dc6783a$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    archivePermissionColumnHeader: {
        id: "archive-pages.nested-page-tree.archive-permissions-column",
        defaultMessage: "Permission to archive"
    },
    canArchiveLabel: {
        id: "archive-pages.nested-page-tree.can-archive",
        defaultMessage: "You have permission to archive"
    },
    noPermissionArchiveLabel: {
        id: "archive-pages.nested-page-tree.no-permission",
        defaultMessage: "You do not have permission to archive"
    },
    nestedContentColumnHeader: {
        id: "archive-pages.nested-content-tree.nested-content-column",
        defaultMessage: "Content"
    },
    limitedContentArchivePermissionTooltip: {
        id: "archive-pages.nested-content-tree.archive.limited-permissions",
        defaultMessage: "You don\u2019t have permission to archive one or more nested items."
    },
    limitedContentRestorePermissionTooltip: {
        id: "archive-pages.nested-content-tree.restore.limited-permissions",
        defaultMessage: "You don\u2019t have permission to restore one or more nested items."
    },
    errorContentTreeTitle: {
        id: "archive-pages.nested-content-tree.error.title",
        defaultMessage: "We couldn\u2019t load the whole content tree"
    }
});
const $10f253e05dc6783a$export$5716e8bcb003888d = 25;
const $10f253e05dc6783a$var$tableTreeDataHelper = new (0, $h6CV4.default)({
    key: 'id'
});
function $10f253e05dc6783a$var$PageTreeWithArchivePermissionsComponent({ contentId: contentId, analyticsSource: analyticsSource, isArchive: isArchive, pageSize: pageSize = $10f253e05dc6783a$export$5716e8bcb003888d, intl: intl }) {
    // parentPageLoadingMap is a mutable object and functions more like a ref; setting
    // values won't trigger a rerender which is what we want (only using it to track
    // pagination values for queries). Maps parent page ID to its loading state.
    const [parentPageLoadingMap, setParentPageLoadingMap] = (0, $42omo.useState)(new Map()); // Keep track of which rows are expanded through a simple array, which will trigger
    // a rerender on update; we may display some content in each row depending on whether it is
    // expanded. Doesn't belong in page tree data, which is permanent / not susceptible to changes.
    const [expandedRows, setExpandedRows] = (0, $42omo.useState)([]);
    const [pageTree, setPageTree] = (0, $42omo.useState)([]);
    const [queryError, setQueryError] = (0, $42omo.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, fetchMore: fetchMore, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query PageTreeWithArchivePermissionsQuery($contentId:ID!$first:Int!$offset:Int!){content(id:$contentId){nodes{children(offset:$offset first:$first){count nodes{id title status operations{operation targetType}links{webui}visibleDescendantsCount archivableDescendantsCount}pageInfo{hasNextPage}}space{key id}id}}}`, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        variables: {
            contentId: contentId,
            first: pageSize,
            offset: 0
        }
    });
    (0, $42omo.useEffect)(()=>{
        (0, $12UWa.fireScreenEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            name: `${(0, $12UWa.getActionName)(isArchive)}PageTreeWithArchivePermissions`
        });
    }, [
        createAnalyticsEvent,
        isArchive
    ]);
    const getContentNodeFromData = (data, contentId)=>{
        const index = (data?.content?.nodes || []).findIndex((node)=>node?.id === contentId);
        return {
            index: index,
            node: index !== -1 ? data.content.nodes[index] : null
        };
    };
    const extractChildPagesData = (0, $42omo.useCallback)((contentNode, parentItem = null)=>{
        const children = contentNode?.children?.nodes || [];
        return children.reduce((pages, currentPage)=>{
            if (!currentPage) return pages;
             // for archive confirmation dialog, filter out archived pages,
            // for restore confirmation dialog, all pages should be archived so no need to filter out any child pages.
            // if we do show child pages of current status then we have a major flaw in our archiving logic
            if (isArchive && currentPage.status !== (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) || !isArchive) {
                const { id: id, title: title, operations: operations, archivableDescendantsCount: archivableDescendantsCount, visibleDescendantsCount: visibleDescendantsCount, links: links } = currentPage;
                pages.push({
                    id: id || '',
                    title: title || '',
                    canArchiveOrUnarchive: (0, $kpLJY.canArchiveContent)(operations || []),
                    hasLimitedDescendantPermissions: archivableDescendantsCount < visibleDescendantsCount,
                    hasChildren: visibleDescendantsCount > 0,
                    parentId: contentNode?.id || '',
                    spaceKey: contentNode?.space?.key || '',
                    parentItem: parentItem,
                    href: links?.webui ? `${0, $jlIaF.CONTEXT_PATH}${links.webui}` : ''
                });
            }
            return pages;
        }, []);
    }, [
        isArchive
    ]);
    const fetchPaginatedData = (0, $42omo.useCallback)((contentId, parentItem = null)=>{
        const parentItemInMap = parentPageLoadingMap.get(contentId); // If parent isn't in map (aka never requested its children before),
        // or if parent IS in map but we haven't loaded all its data, fetch more
        if (!parentItemInMap || parentItemInMap.hasNextPage && !parentItemInMap.isLoading) {
            if (parentItemInMap) setParentPageLoadingMap(parentPageLoadingMap.set(contentId, {
                ...parentItemInMap,
                isLoading: true
            }));
            const offset = parentItemInMap ? parentItemInMap.offset : 0;
            fetchMore({
                variables: {
                    contentId: contentId,
                    first: pageSize,
                    offset: offset
                },
                // Use "any" for results type just so that we don't have to silence
                // or disable TS on every line of this function
                updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                    if (!fetchMoreResult) return prev;
                    const fetchMoreNode = fetchMoreResult.content.nodes[0]; // The main query for this component can get executed many times with disparate inputs
                    // (different content IDs and different pagination values). Even though each individual query
                    // execution will return a single content node (with possibly many children), we may have
                    // multiple content nodes to track when merging, from various executions with different content
                    // IDs, so do additional logic to maintain the entire resultset.
                    const { index: index, node: prevNode } = getContentNodeFromData(prev, contentId);
                    const prevNodeChildren = prevNode?.children?.nodes ?? [];
                    const newCount = prevNodeChildren.length + fetchMoreNode.children.nodes.length;
                    const newParentNode = {
                        ...fetchMoreNode,
                        children: {
                            ...fetchMoreNode.children,
                            count: newCount,
                            nodes: [
                                // add on this content node's previous existing children if necessary
                                ...prevNodeChildren,
                                ...fetchMoreNode.children.nodes
                            ],
                            pageInfo: {
                                ...fetchMoreNode.children.pageInfo
                            },
                            __typename: 'PaginatedContentList'
                        }
                    };
                    let newNodes;
                    if (index === -1) newNodes = [
                        ...prev.content.nodes,
                        newParentNode
                    ];
                    else {
                        prev.content.nodes.splice(index, 1, newParentNode);
                        newNodes = [
                            ...prev.content.nodes
                        ];
                    }
                    const newData = {
                        content: {
                            nodes: newNodes,
                            __typename: 'PaginatedContentListWithChild'
                        }
                    };
                    return newData;
                }
            }).then((result)=>{
                const { data: data } = result; // we only receive the NEW data in this callback, so it will always be a single content node at index 0
                const newContentNode = data?.content?.nodes?.[0];
                const parentId = newContentNode?.id;
                const pageInfo = newContentNode?.children?.pageInfo;
                const prevOffset = parentItemInMap ? parentItemInMap.offset : 0;
                const childCount = parseInt(newContentNode?.children?.count + prevOffset);
                const childItems = extractChildPagesData(newContentNode, parentItem); // Keep track of where we left off with loading this parent's children
                setParentPageLoadingMap(parentPageLoadingMap.set(parentId, {
                    ...parentItemInMap,
                    hasNextPage: pageInfo && pageInfo.hasNextPage,
                    offset: childCount,
                    lastLoadedChildId: childItems.length ? childItems[childItems.length - 1].id : null,
                    isLoading: false
                }));
                if (prevOffset === 0) // add child items for the first time
                setPageTree($10f253e05dc6783a$var$tableTreeDataHelper.updateItems(childItems, pageTree, parentItem));
                else // append child items onto an existing list
                setPageTree($10f253e05dc6783a$var$tableTreeDataHelper.appendItems(childItems, pageTree, parentItem));
            }).catch((error)=>{
                // fetchMore errors are not surfaced in initial useQuery error.
                setQueryError(error);
            });
        }
    }, [
        extractChildPagesData,
        fetchMore,
        pageSize,
        pageTree,
        parentPageLoadingMap
    ]);
    (0, $42omo.useEffect)(()=>{
        // Construct page tree for first time on mount.
        // We may have multiple query results in the cache, and need to find top level children (matching prop contentId)
        const { node: node } = getContentNodeFromData(data, contentId);
        if (node && !pageTree.length) {
            const hasNextPage = node?.children?.pageInfo?.hasNextPage;
            const childCount = node?.children?.count;
            const childItems = extractChildPagesData(node); // If this component is being re-mounted (eg after clicking 'hide' and then 'show' from the confirmation dialog),
            // we already have page tree data loaded locally, so don't reset our loading map.
            // Resetting it could cause us to re-fetch and duplicate subsequent pages of data that we already have loaded.
            if (!parentPageLoadingMap.has(contentId)) setParentPageLoadingMap(parentPageLoadingMap.set(contentId, {
                hasNextPage: hasNextPage,
                offset: childCount,
                lastLoadedChildId: childItems.length ? childItems[childItems.length - 1].id : null
            }));
            if (!childItems.length) // it's possible for us to have data but no child page items, e.g. if
            // every child in the first X pages of data happens to be status = archived
            // In that case, we need to start fetching the next page of data manually.
            // Usually, we'll start fetching more data "on demand" from the user --
            // aka when they scroll into view a dynamically generated spinner row (see LoadRowsSpinner)
            // that automatically triggers fetching the next page of data for any parent.
            // But in this case, we've already fetched X pages of data and STILL have nothing to
            // render except our initial static "give me a sec, I'm loading" spinner. So keep fetching!
            fetchPaginatedData(contentId);
            else // begin rendering our page tree if we have data
            setPageTree($10f253e05dc6783a$var$tableTreeDataHelper.updateItems(childItems, pageTree));
        }
    }, [
        data,
        setPageTree,
        pageTree,
        contentId,
        parentPageLoadingMap,
        extractChildPagesData,
        fetchPaginatedData
    ]);
    const loadChildren = (parentItem)=>{
        if (parentItem) // we are loading more children for a specific parent row in the table
        fetchPaginatedData(parentItem.id, parentItem);
        else // we are loading top-level children (not linked to a parent row)
        fetchPaginatedData(contentId);
    }; // While there are currently only two interactions that we track (expand & collapse), they are
    const firePageTreeUIEvent = (0, $42omo.useCallback)((interaction, contentId)=>{
        (0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'button',
            actionSubjectId: `${interaction}ParentPage`,
            source: analyticsSource,
            attributes: {
                contentId: contentId
            }
        });
    }, [
        createAnalyticsEvent,
        analyticsSource
    ]);
    const expandParent = (parentItem)=>{
        if (!expandedRows.includes(parentItem.id)) {
            firePageTreeUIEvent('expand', parentItem.id);
            setExpandedRows([
                ...expandedRows,
                parentItem.id
            ]);
        } // If parentItem already has children locally (e.g. case where user is reexpanding after a previous collapse),
        //   don't do anything; the table tree component will take care of rendering the children.
        // If parentItem has no children in the page tree BUT has cached data (e.g. from a previous mount), construct
        //   the nested page tree without making a network call. (If not all child data was loaded the first time around,
        //   we'll have tracked that in the loading state map and will fetch the next page of child data when user scrolls.
        // Else, make a network call.
        if (!parentItem.children || !parentItem.children.length) {
            const { node: node } = getContentNodeFromData(data, parentItem.id);
            if (node) setPageTree($10f253e05dc6783a$var$tableTreeDataHelper.updateItems(extractChildPagesData(node, parentItem), pageTree, parentItem));
            else // we have no cached data to construct children from so
            // go ahead and load it ad-hoc
            loadChildren(parentItem);
        }
    };
    const collapseParent = (parentItem)=>{
        if (expandedRows.includes(parentItem.id)) {
            firePageTreeUIEvent('collapse', parentItem.id);
            setExpandedRows(expandedRows.filter((id)=>id !== parentItem.id));
        }
    }; // TS complains if I put this actual expression inside the jsx. :shrug:
    const anyError = queryError || error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dlke8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10f253e05dc6783a$var$StyledTableHeaders, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e7vmR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CdIqF.default), {
        width: 375
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $10f253e05dc6783a$export$a7357cdd1f0b0168.nestedContentColumnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CdIqF.default), {
        width: 230,
        id: "permission-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $10f253e05dc6783a$export$a7357cdd1f0b0168.archivePermissionColumnHeader)))), anyError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ubeQ2.ErrorSectionMessage), {
        title: $10f253e05dc6783a$export$a7357cdd1f0b0168.errorContentTreeTitle,
        error: anyError
    }) : null, pageTree.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10f253e05dc6783a$var$TableTreeContentsContainer, {
        id: "table-tree-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39F3L.default), {
        items: pageTree,
        render: ({ id: id, title: title, children: children, hasChildren: hasChildren, canArchiveOrUnarchive: canArchiveOrUnarchive, hasLimitedDescendantPermissions: hasLimitedDescendantPermissions, parentId: parentId, parentItem: parentItem, spaceKey: spaceKey, href: href })=>// TableTree is very picky about exactly what is returned in the <Rows> render() function.
            // To get children rows to expand and display properly, the row must have <Row> as the outermost
            // React node (for example, wrapping it even with <Fragment> messes up the rendering), which is why
            // we call a function to get the row contents rather than using a function component.
            // Unfortunately this render pattern seems to mean that EVERY row rerenders whenever data updates, even
            // unrelated (not-same-level) rows. :sad-face:
            $10f253e05dc6783a$export$42035f545ecd5428({
                id: id,
                title: title,
                childItems: children || [],
                hasChildren: hasChildren,
                canArchiveOrUnarchive: canArchiveOrUnarchive,
                hasLimitedDescendantPermissions: hasLimitedDescendantPermissions,
                parentId: parentId,
                parentItem: parentItem,
                loadMoreData: loadChildren,
                expandRow: expandParent,
                collapseRow: collapseParent,
                spaceKey: spaceKey,
                parentPageLoadingMap: parentPageLoadingMap,
                expandedRows: expandedRows,
                isArchive: isArchive,
                intl: intl,
                href: href
            })
    })) : !anyError && loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10f253e05dc6783a$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium",
        testId: "archive-pagetree-loading-spinner"
    })));
}
const $10f253e05dc6783a$export$58aad44169207bd8 = (0, $gmMgo.default)($10f253e05dc6783a$var$PageTreeWithArchivePermissionsComponent);
const $10f253e05dc6783a$export$42035f545ecd5428 = ({ id: id, childItems: childItems, hasChildren: hasChildren, expandRow: expandRow, collapseRow: collapseRow, title: title, canArchiveOrUnarchive: canArchiveOrUnarchive, hasLimitedDescendantPermissions: hasLimitedDescendantPermissions, parentId: parentId, parentItem: parentItem, loadMoreData: loadMoreData, parentPageLoadingMap: parentPageLoadingMap, expandedRows: expandedRows, isArchive: isArchive, intl: intl, href: href })=>{
    // If this is the last loaded child for its parent, but its parent
    // hasn't finished loading all pages of data, display a spinner
    const parentLoadingItem = parentPageLoadingMap.get(parentId);
    return parentLoadingItem && parentLoadingItem.hasNextPage && parentLoadingItem.lastLoadedChildId === id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60KKo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhDw8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4B2M3.ObservableSpinner), {
        onScrollTo: ()=>loadMoreData(parentItem),
        testId: "archive-pagetree-paginating-spinner",
        observerOptions: {
            root: document.getElementById('table-tree-body'),
            rootMargin: '100px 0px 0px 0px'
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60KKo.default), {
        itemId: id,
        items: childItems,
        hasChildren: hasChildren,
        onExpand: expandRow,
        onCollapse: collapseRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhDw8.default), {
        singleLine: true
    }, // Table tree prepends parent rows with clickable chevron icon; we add on
    // a static aligned bullet icon for non-parent rows
    !hasChildren ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d01b0a3f79209a8$export$1af6e64869692b36), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        className: "rowTitle",
        target: "_blank",
        href: href
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10f253e05dc6783a$var$PermissionCell, {
        singleLine: true
    }, // only show the 'limited permissions' icon, indicating that current row has descendants
    // with no archive permission, if descendants are not expanded
    !expandedRows.includes(id) && hasLimitedDescendantPermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isArchive ? intl.formatMessage($10f253e05dc6783a$export$a7357cdd1f0b0168.limitedContentArchivePermissionTooltip) : intl.formatMessage($10f253e05dc6783a$export$a7357cdd1f0b0168.limitedContentRestorePermissionTooltip),
        tag: "span",
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-warning, #E56910)",
        testId: `limited-permissions-icon-${id}`
    })) : null, canArchiveOrUnarchive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        spacing: "spacious",
        label: intl.formatMessage($10f253e05dc6783a$export$a7357cdd1f0b0168.canArchiveLabel),
        color: "var(--ds-icon-success, #22A06B)",
        testId: `has-archive-permission-icon-${id}`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
        spacing: "spacious",
        label: intl.formatMessage($10f253e05dc6783a$export$a7357cdd1f0b0168.noPermissionArchiveLabel),
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `no-archive-permission-icon-${id}`
    })));
};



var $5Tdv2 = parcelRequire("5Tdv2");


var $f473b = parcelRequire("f473b");


var $ewt2O = parcelRequire("ewt2O");

const $dc5714247bc0c94d$export$83ef1d880f1d72e = 'archive-pages-inherited-restrictions-warning';
const $dc5714247bc0c94d$export$3bdee4eeb1f24ec1 = 'archive-pages-own-restrictions-warning';
const $dc5714247bc0c94d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    archiveNestedPagesDialogCheckboxDescriptionGeneric: {
        id: "archive-pages.allow-page-nested.archive.dialog.checkbox.description.generic",
        defaultMessage: "{count, plural, one {\u201C{title}\u201D has 1 nested item. Check the box if you\u2019d like to archive it, too.} other {\u201C{title}\u201D has {count} nested items. Check the box if you\u2019d like to archive them, too.}}"
    },
    archiveNestedPagesNoPermissionDialogDescription: {
        id: "archive-pages.allow-page-nested.archive.no-permission.dialog.description.M2",
        defaultMessage: "{count, plural, one {\u201C{title}\u201D has 1 nested item.} other {\u201C{title}\u201D has {count} nested items.}}"
    },
    archiveNestedPageSelectionLimitReachedWarningMessageV2: {
        id: "archive-pages.allow-page-nested.archive.selection-limit-reached.dialog.description.v2",
        defaultMessage: "{count, plural, one {\u201C{title}\u201D has 1 nested item.} other {\u201C{title}\u201D has {count} nested items.}}"
    },
    unarchiveNestedPagesDialogRadioDescriptionMessage: {
        id: "archive-pages.allow-page-nested.unarchive.dialog.radio.description.message",
        defaultMessage: "{count, plural, one {\u201C{title}\u201D has 1 nested item. Do you want to restore the entire branch?} other {\u201C{title}\u201D has {count} nested items. Do you want to restore the entire branch?}}"
    },
    unarchiveNestedPagesNoPermissionDialogDescription: {
        id: "archive-pages.allow-page-nested.unarchive.no-permission.dialog.description",
        defaultMessage: "{count, plural, one {\u201C{title}\u201D has 1 nested item.} other {\u201C{title}\u201D has {count} nested items.}}"
    },
    unarchiveNestedPageSelectionLimitReachedWarningMessage: {
        id: "archive-pages.allow-page-nested.unarchive.selection-limit-reached.dialog.description",
        defaultMessage: "{count, plural, one {\u201C{title}\u201D has 1 nested item. It won\u2019t be restored - only 500 items can move at a time.} other {\u201C{title}\u201D has {count} nested items. They won\u2019t be restored - only 500 items can move at a time.}}"
    },
    archivePageDialogDescription: {
        id: "archive-pages.page-nested.archive.dialog.description",
        defaultMessage: "Archiving \u201C{title}\u201D may change who can see the items nested below it."
    },
    archivePageDialogDescriptionWithRestrictionsWarnings: {
        id: "archive-pages.page-nested.archive.dialog.restrictions-warnings-enabled.description",
        defaultMessage: "\u201C{title}\u201D will be archived but its nested items will remain in the content tree."
    },
    unarchivePageWithChildrenDialogBody: {
        id: "archive-pages.page-nested.unarchive.dialog.body",
        defaultMessage: "Restoring \u201C{title}\u201D may change who can see the items nested below it."
    },
    draftsCantBeArchived: {
        id: "archive-pages.drafts-archive-message",
        defaultMessage: "*Drafts can\u2019t be archived"
    },
    includeNestedPagesArchiveLabel: {
        id: "archive-pages.archive-nested-message.M2",
        defaultMessage: "Include nested items"
    },
    includeNestedPagesRestoreLabel: {
        id: "archive-pages.restore-nested-message",
        defaultMessage: "{count, plural, one {Restore {count} nested item.} other {Restore {count} nested items}}"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc5714247bc0c94d$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc5714247bc0c94d$var$MessageTextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _2hwx1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc5714247bc0c94d$var$MessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $dc5714247bc0c94d$var$optionsContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc5714247bc0c94d$var$PageTreeContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zl187z",
            __cmplp.className
        ])
    });
});
const $dc5714247bc0c94d$export$99adedd72b6c28f = 'includeNestedPages';
const $dc5714247bc0c94d$export$7a0329b34fa7d0af = 'excludeNestedPages';
const $dc5714247bc0c94d$export$2140ee6de4cc078e = ({ contentId: contentId, allowNestedPages: allowNestedPages, includeNestedPages: includeNestedPages, setIncludeNestedPages: setIncludeNestedPages, setDescendantsNoteApplicationOption: setDescendantsNoteApplicationOption = ()=>{}, isArchive: isArchive, analyticsSource: analyticsSource, hasInheritedRestrictions: hasInheritedRestrictions = false, hasOwnRestrictions: hasOwnRestrictions = false })=>{
    const { data: data, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ArchiveConfirmationMessageQuery($contentId:ID!$showCount:Boolean!){singleContent(id:$contentId){id archivableDescendantsCount@include(if:$showCount)visibleDescendantsCount@include(if:$showCount)}}`, {
        variables: {
            contentId: contentId,
            showCount: allowNestedPages
        }
    });
    const countNestedPages = data?.singleContent?.visibleDescendantsCount || 0;
    const isSelectionLimitReached = allowNestedPages ? countNestedPages + 1 > (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT) : false;
    const [showPageTree, setShowPageTree] = (0, $42omo.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        (0, $12UWa.fireScreenEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            name: analyticsSource
        });
    }, [
        createAnalyticsEvent,
        analyticsSource
    ]);
    const handleShowPageTreeClick = (0, $42omo.useCallback)((shouldIncludeNestedPages)=>{
        (0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'link',
            actionSubjectId: 'togglePageTreeLink',
            source: analyticsSource,
            attributes: {
                pageTreeState: shouldIncludeNestedPages ? 'show' : 'hide'
            }
        });
        setShowPageTree(shouldIncludeNestedPages);
    }, [
        createAnalyticsEvent,
        analyticsSource
    ]);
    const handleNestedOptionChange = (0, $42omo.useCallback)((shouldIncludeNestedPages)=>{
        setIncludeNestedPages(()=>{
            // TODO: CCAXP-61 update actionSubject potentially?
            if (shouldIncludeNestedPages === false) setDescendantsNoteApplicationOption((0, $ewt2O.DescendantsNoteApplicationOption).NONE);
            (0, $12UWa.fireUIClickEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                actionSubject: 'radioButton',
                actionSubjectId: 'includeNestedPagesSelection',
                source: analyticsSource,
                attributes: {
                    includeNestedPages: shouldIncludeNestedPages
                }
            });
            return shouldIncludeNestedPages;
        });
    }, [
        setIncludeNestedPages,
        createAnalyticsEvent,
        analyticsSource,
        setDescendantsNoteApplicationOption
    ]);
    const archivableDescendantsCount = data?.singleContent?.archivableDescendantsCount ?? null;
    const visibleDescendantsCount = data?.singleContent?.visibleDescendantsCount ?? 0;
    (0, $42omo.useEffect)(()=>{
        const isIncludeNestedDefault = !allowNestedPages; /*
                                                               Select "include nested pages" as default option IFF user has permission to archive/restore at least one descendant.
                                                               Otherwise, we won't display the radio group at all (user effectively has no choice since they are unable
                                                               to archive/restore ANY descendants).
                                                               We wait till we have valid data (here) to set the default option so there is no jumping between selected options.
                                                              */ 
        if (isIncludeNestedDefault && !(0, (/*@__PURE__*/$parcel$interopDefault($3pgvV)))(archivableDescendantsCount)) {
            if (archivableDescendantsCount > 0 && !isSelectionLimitReached) setIncludeNestedPages(true);
        }
    }, [
        allowNestedPages,
        archivableDescendantsCount,
        setIncludeNestedPages,
        isSelectionLimitReached
    ]); // Using "!data" instead of "loading" with "cache-and-network", as "load" can be true when
    // cached data is available and cause flickering due to reallocating subcomponents
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data && allowNestedPages) return null;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3pgvV)))(archivableDescendantsCount)) return null;
    const getI18nMainMessage = ()=>{
        if (allowNestedPages) {
            if (isSelectionLimitReached) return isArchive ? $dc5714247bc0c94d$export$a7357cdd1f0b0168.archiveNestedPageSelectionLimitReachedWarningMessageV2 : $dc5714247bc0c94d$export$a7357cdd1f0b0168.unarchiveNestedPageSelectionLimitReachedWarningMessage;
            else if (archivableDescendantsCount === 0) // Else no permission to archive or restore any of the descendants
            return isArchive ? $dc5714247bc0c94d$export$a7357cdd1f0b0168.archiveNestedPagesNoPermissionDialogDescription : $dc5714247bc0c94d$export$a7357cdd1f0b0168.unarchiveNestedPagesNoPermissionDialogDescription;
            else // Else some or all of the descendants can be archived or restored
            return isArchive ? $dc5714247bc0c94d$export$a7357cdd1f0b0168.archiveNestedPagesDialogCheckboxDescriptionGeneric : $dc5714247bc0c94d$export$a7357cdd1f0b0168.unarchiveNestedPagesDialogRadioDescriptionMessage;
        } else // else allowNestedPages === false
        return isArchive ? $dc5714247bc0c94d$export$a7357cdd1f0b0168.archivePageDialogDescriptionWithRestrictionsWarnings : $dc5714247bc0c94d$export$a7357cdd1f0b0168.unarchivePageWithChildrenDialogBody;
    };
    const i18nNestedLabel = isArchive ? $dc5714247bc0c94d$export$a7357cdd1f0b0168.includeNestedPagesArchiveLabel : $dc5714247bc0c94d$export$a7357cdd1f0b0168.includeNestedPagesRestoreLabel; // Note that items can have both inherited and own restrictions at the same time.  This is
    // because restrictions are additive: own restrictions are layered on top of any restrictions
    // already inherited by that item. That means moving or changing what an item inherits from will
    // always change that item's restrictions and that of any item underneath it. (Also note - and
    // this only applies to Bulk Archiving - that once a page has own or inherited restrictions then
    // its all its children will have inherited restrictions; there's no way to get back to the "no
    // restrictions" state further down that branch.)
    //
    // The rules for showing the restriction warnings are as follows:
    //  1. If an item has inherited restrictions and it or any of its children are archived, then
    //     warn about the items losing their restrictions in the archive
    //  2. If an item with own restrictions is archived and of any of its children are not included,
    //     then warn about moving the remaining items up in the tree
    //  There are also additional rules that only apply to Bulk Archiving - one that applies only
    //  when the selected item has only isn't archived and one that only applies to excluded items on
    //  Bulk Archive - that don't apply here. See comments in BulkArchivePagesConfirmationDialog.tsx
    //  for those rules.)
    //
    // Note that showing both restriction warnings is possible: when an item has both inherited and
    // own restrictions and some of the children aren't included - either because the user chose not
    // to archive the children or some children don't have permission. In those cases, the children
    // that will be archived need the "losing inheritence in archive" warning, while the children
    // that aren't archived will lose the parent's own restrictions and thus need the own
    // restrictions "moving up the page tree" warning too.
    const getInheritedRestrictionsWarningMessage = ()=>{
        // If the selected item has inherited restrictions, show a warning message about the selected
        // item and its children losing their restrictions if archived or just the selected item
        // losing it restrictions if no children are included. (Note that selected items that
        // don't have any children don't end up in this component at all)
        if (hasInheritedRestrictions) // Treat the operation as not including nested pages if the user doesn't have permission to
        // archive any of the nested pages. Also, if the selection limit has been reached, we only
        // allow the user to archive the selected item and not any of the children.
        return includeNestedPages && archivableDescendantsCount > 0 && !isSelectionLimitReached ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tdv2.RestrictionsWarningMessage), {
            dataTestid: $dc5714247bc0c94d$export$83ef1d880f1d72e,
            title: (0, $f473b.archivePagesRestrictionWarningsI18n).inheritedRestrictionsPageAndChildrenTitle,
            message: (0, $f473b.archivePagesRestrictionWarningsI18n).inheritedRestrictionsPageAndChildrenMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tdv2.RestrictionsWarningMessage // It's okay for this intance to share the same data-testid as the previous on since
        ), {
            // they should never be shown at the same time
            dataTestid: $dc5714247bc0c94d$export$83ef1d880f1d72e,
            title: (0, $f473b.archivePagesRestrictionWarningsI18n).inheritedRestrictionsPageOnlyTitle,
            message: (0, $f473b.archivePagesRestrictionWarningsI18n).inheritedRestrictionsPageOnlyMessage
        });
         // Else the selected item doesn't have inherited restrictions, so we don't need a warning message
        return null;
    };
    const getOwnRestrictionsWarningMessage = ()=>{
        // If the selected item has its own restrictions and the some or all of the children aren't
        // aren't being archived, show the warning message about the children changing their
        // restrictions because they are moving up in the page tree.
        // (Note that if the selected item has its only own restrictions, then archiving it with all
        //  of its children will keep all their restrictions intact, so no warning is needed in that
        //  case.)
        if (hasOwnRestrictions) {
            // If any of the nested items are not being archived, show a message that they will lose
            // some of all of their restrictions. Note that when the selection limit has been reached,
            // we only allow the user to archive the selected item and not any of the children. Also
            // remember, we have to have some children here because selected items that don't have any
            // children won't end up in this component at all.
            if (!includeNestedPages || archivableDescendantsCount < visibleDescendantsCount || isSelectionLimitReached) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tdv2.RestrictionsWarningMessage), {
                dataTestid: $dc5714247bc0c94d$export$3bdee4eeb1f24ec1,
                title: (0, $f473b.archivePagesRestrictionWarningsI18n).ownRestrictionsChildrenTitle,
                message: (0, $f473b.archivePagesRestrictionWarningsI18n).ownRestrictionsChildrenMessage
            });
        } // There are no own restriction cases that need a warning, so return nothing
        return null;
    };
    const getRestoreInheritedRestrictionsWarningMessage = ()=>{
        // If the selected item has inherited restrictions, show a warning message about the selected
        // item and its children losing their restrictions if restored or just the selected item
        // losing it restrictions if no children are included. (Note that selected items that
        // don't have any children don't end up in this component at all)
        if (hasInheritedRestrictions) // Treat the operation as not including nested pages if the user doesn't have permission to
        // archive any of the nested pages. Also, if the selection limit has been reached, we only
        // allow the user to archive the selected item and not any of the children.
        return includeNestedPages && archivableDescendantsCount > 0 && !isSelectionLimitReached ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tdv2.RestrictionsWarningMessage), {
            title: (0, $iJ15L.unarchivePagesRestrictionWarningsI18n).unarchiveInheritedRestrictionsWithChildrenWarningTitle,
            message: (0, $iJ15L.unarchivePagesRestrictionWarningsI18n).unarchiveInheritedRestrictionsWithChildrenWarningMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tdv2.RestrictionsWarningMessage), {
            title: (0, $iJ15L.unarchivePagesRestrictionWarningsI18n).unarchiveInheritedRestrictionsNoChildrenWarningTitle,
            message: (0, $iJ15L.unarchivePagesRestrictionWarningsI18n).unarchiveInheritedRestrictionsNoChildrenWarningMessage
        });
         // Else the selected item doesn't have inherited restrictions, so we don't need a warning message
        return null;
    };
    const getRestoreOwnRestrictionsWarningMessage = ()=>{
        // If the selected item has its own restrictions and the some or all of the children aren't
        // aren't being restored, show the warning message about the children changing their
        // restrictions because they are moving up in the page tree.
        // (Note that if the selected item has its only own restrictions, then restoring it with all
        //  of its children will keep all their restrictions intact, so no warning is needed in that
        //  case.)
        if (hasOwnRestrictions) {
            // If any of the nested items are not being restored, show a message that they will lose
            // some of all of their restrictions. Note that when the selection limit has been reached,
            // we only allow the user to restore the selected item and not any of the children. Also
            // remember, we have to have some children here because selected items that don't have any
            // children won't end up in this component at all.
            if (!includeNestedPages || archivableDescendantsCount < visibleDescendantsCount || isSelectionLimitReached) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tdv2.RestrictionsWarningMessage), {
                title: (0, $iJ15L.unarchivePagesRestrictionWarningsI18n).unarchiveOwnRestrictionsNoChildrenWarningTitle,
                message: (0, $iJ15L.unarchivePagesRestrictionWarningsI18n).unarchiveOwnRestrictionsNoChildrenWarningMessage
            });
        } // There are no own restriction cases that need a warning, so return nothing
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc5714247bc0c94d$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc5714247bc0c94d$var$MessageContainer, {
        "data-testid": "archive-confirmation-msg-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc5714247bc0c94d$var$MessageTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i9XHg.ArchiveFormattedMessageForPage), {
        contentId: contentId,
        i18nMessage: getI18nMainMessage(),
        allowNestedPages: allowNestedPages,
        useArchivableCount: false,
        shouldTruncate: true
    }))), allowNestedPages ? !isSelectionLimitReached && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, archivableDescendantsCount === 0 ? null : // show checkbox if there is at least 1 nested page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $dc5714247bc0c94d$var$optionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...i18nNestedLabel,
            values: {
                count: visibleDescendantsCount
            }
        }),
        onChange: ()=>{
            const shouldIncludeNestedPages = !Boolean(includeNestedPages);
            handleNestedOptionChange(shouldIncludeNestedPages);
            handleShowPageTreeClick(shouldIncludeNestedPages);
        },
        isChecked: Boolean(includeNestedPages),
        name: "checkbox-include-nested-pages",
        testId: "cb-include-nested-pages"
    }))) : null, allowNestedPages && // Show permission warning if the selection limit has been reached.
    (isSelectionLimitReached || // Show nested pages warning if user opted to include descendants (includeNestedPages = true)
    // OR if we didn't give user the option to include/exclude (includeNestedPages = null).
    // The nested pages permission warning is irrelevant if user opts to exclude nested pages.
    includeNestedPages !== false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $81c5fd94c923765e$export$4e740b2872facc4d), {
        isArchive: isArchive,
        contentId: contentId,
        isSelectionLimitReached: isSelectionLimitReached
    }), isArchive && getInheritedRestrictionsWarningMessage(), isArchive && getOwnRestrictionsWarningMessage(), !isArchive && getRestoreInheritedRestrictionsWarningMessage(), !isArchive && getRestoreOwnRestrictionsWarningMessage(), showPageTree && // This check ensures that the page tree is not shown when the selection limit has been reached
    !isSelectionLimitReached ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc5714247bc0c94d$var$PageTreeContainer, {
        "data-testid": "table-tree-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10f253e05dc6783a$export$58aad44169207bd8), {
        contentId: contentId,
        analyticsSource: analyticsSource,
        isArchive: isArchive
    })) : null);
};
const $dc5714247bc0c94d$export$75861abf00087cf2 = (0, $gmMgo.default)($dc5714247bc0c94d$export$2140ee6de4cc078e);
module.exports["ArchiveConfirmationMessage"] = $dc5714247bc0c94d$export$75861abf00087cf2;

});

parcelRegister("i9XHg", function(module, exports) {
/* ArchiveFormattedMessageForPage.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $gtD4K = parcelRequire("gtD4K");


var $xQxzY = parcelRequire("xQxzY");


var $3pgvV = parcelRequire("3pgvV");


var $3gadb = parcelRequire("3gadb");


var $b3j2Y = parcelRequire("b3j2Y");

const $37d37239df6c43af$var$TruncatedTitle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bto1l2s _p12f1lit _k48p1wq8 _o5721q9c _s7n4yfq0",
            __cmplp.className
        ])
    });
});
const $37d37239df6c43af$export$617b6ebf37a711a7 = ({ contentId: contentId, i18nMessage: i18nMessage, shouldTruncate: shouldTruncate = false, allowNestedPages: allowNestedPages, useArchivableCount: useArchivableCount = false })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ArchiveFormattedMessageForPageQuery($contentId:ID!$allowNestedPages:Boolean!){singleContent(id:$contentId){id title archivableDescendantsCount@include(if:$allowNestedPages)visibleDescendantsCount@include(if:$allowNestedPages)}}`, {
        variables: {
            contentId: contentId,
            allowNestedPages: allowNestedPages
        }
    });
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const title = data?.singleContent?.title;
    const visibleDescendantsCount = data?.singleContent?.visibleDescendantsCount;
    const archivableDescendantsCount = data?.singleContent?.archivableDescendantsCount; // return null if title didn't return or nested pages is allowed but
    // visibleDescendantsCount is null, meaning either invalid content or
    // error while calculating count
    if (!title || allowNestedPages && (0, (/*@__PURE__*/$parcel$interopDefault($3pgvV)))(visibleDescendantsCount)) return null;
    const formattedTitle = shouldTruncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d37239df6c43af$var$TruncatedTitle, null, title)) : title;
    return i18nMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...i18nMessage,
        values: {
            title: formattedTitle,
            count: useArchivableCount ? archivableDescendantsCount : visibleDescendantsCount
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, formattedTitle);
};
module.exports["ArchiveFormattedMessageForPage"] = $37d37239df6c43af$export$617b6ebf37a711a7;

});

parcelRegister("iJ15L", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $41a1e47b491ff815$export$d0fdc6e8979c00c1 = (0, $cgtv4.defineMessages)({
    unarchiveInheritedRestrictionsNoChildrenWarningTitle: {
        id: "archive-pages.unarchive.restrictions.inherited.no-children.title",
        defaultMessage: "Access to this item will change"
    },
    unarchiveInheritedRestrictionsNoChildrenWarningMessage: {
        id: "archive-pages.unarchive.restrictions.inherited.no-children.message",
        defaultMessage: "This item is restricted by a parent. After restoring, its access will be based on its new position in the content tree. <a>Learn more about inherited restrictions</a>"
    },
    unarchiveInheritedRestrictionsWithChildrenWarningTitle: {
        id: "archive-pages.unarchive.restrictions.inherited.with-children.title",
        defaultMessage: "Access to restored items will change"
    },
    unarchiveInheritedRestrictionsWithChildrenWarningMessage: {
        id: "archive-pages.unarchive.restrictions.inherited.with-children.message",
        defaultMessage: "These items are restricted by a parent. After restoring, their access will be based on their new position in the content tree. <a>Learn more about inherited restrictions</a>"
    },
    unarchiveOwnRestrictionsNoChildrenWarningTitle: {
        id: "archive-pages.unarchive.restrictions.own.no-children.title",
        defaultMessage: "Access to remaining nested items will change"
    },
    unarchiveOwnRestrictionsNoChildrenWarningMessage: {
        id: "archive-pages.unarchive.restrictions.own.no-children.message",
        defaultMessage: "These items are restricted by the parent you\u2019re restoring. After restoring, their access will be based on their new position in the archive. <a>Learn more about inherited restrictions</a>"
    }
});
module.exports["unarchivePagesRestrictionWarningsI18n"] = $41a1e47b491ff815$export$d0fdc6e8979c00c1;

});

parcelRegister("iwOJa", function(module, exports) {

let $d7d2908e97bb3005$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7d2908e97bb3005$var$load("in6Mc").then(()=>parcelRequire('9bDdV'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("5Tdv2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $aoVih = parcelRequire("aoVih");


var $9wGTI = parcelRequire("9wGTI");


var $aqBZ0 = parcelRequire("aqBZ0");


var $cgtv4 = parcelRequire("cgtv4");

const $c597f48c59c75c1b$export$54e042590f005d08 = (0, $cgtv4.defineMessages)({
    archiveInheritedRestrictionsInfoLinkAriaDescription: {
        id: "archive-pages.dialog.archive.inherited-restrictions.info.link.aria-description",
        defaultMessage: "inherited view restrictions - link opens in a new tab"
    }
});


const $309107c9cc43facb$export$966891553cd13619 = ({ title: title, message: message, dataTestid: dataTestid = 'archive-pages-restrictions-warning-message', hasMessagePadding: hasMessagePadding = true })=>{
    const intl = (0, $8C5kA.default)();
    const viewRestrictionSupportLink = {
        a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__admin-experien') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                "aria-label": intl.formatMessage((0, $c597f48c59c75c1b$export$54e042590f005d08).archiveInheritedRestrictionsInfoLinkAriaDescription),
                target: "_blank",
                href: (0, $aqBZ0.PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK)
            }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                "aria-label": intl.formatMessage((0, $c597f48c59c75c1b$export$54e042590f005d08).archiveInheritedRestrictionsInfoLinkAriaDescription),
                target: "_blank",
                href: (0, $aqBZ0.PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK)
            }, chunks)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            paddingBlock: hasMessagePadding ? 'space.200' : 'space.0'
        }),
        testId: dataTestid.concat('-container')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning",
        title: intl.formatMessage(title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        testId: dataTestid,
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...message,
        values: {
            lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null),
            ...viewRestrictionSupportLink
        }
    }))));
};
module.exports["RestrictionsWarningMessage"] = $309107c9cc43facb$export$966891553cd13619;

});

parcelRegister("f473b", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $e746a1c385e2631b$export$77cf259b67e812fb = (0, $cgtv4.defineMessages)({
    inheritedRestrictionsPageOnlyTitle: {
        id: "archive-pages.restrictions-warning.page-only.inherited-restrictions.title",
        defaultMessage: "Access to the archived item will change"
    },
    inheritedRestrictionsPageOnlyMessage: {
        id: "archive-pages.restrictions-warning.page-only.inherited-restrictions.message",
        defaultMessage: "This item is restricted by a parent. After archiving, those restrictions won\u2019t apply. <a>Learn more about inherited restrictions</a>"
    },
    inheritedRestrictionsPageAndChildrenTitle: {
        id: "archive-pages.restrictions-warning.page-and-children.inherited-restrictions.title",
        defaultMessage: "Access to archived items will change"
    },
    inheritedRestrictionsPageAndChildrenMessage: {
        id: "archive-pages.restrictions-warning.page-and-children.inherited-restrictions.message",
        defaultMessage: "These items are restricted by a parent. After archiving, those restrictions won\u2019t apply. <a>Learn more about inherited restrictions</a>"
    },
    ownRestrictionsChildrenTitle: {
        id: "archive-pages.restrictions-warning.children-only.own-restrictions.title",
        defaultMessage: "Access to remaining nested items will change"
    },
    ownRestrictionsChildrenMessage: {
        id: "archive-pages.restrictions-warning.children-only.own-restrictions.message",
        defaultMessage: "These items are restricted by the parent you\u2019re archiving. After archiving, their access will be based on their new position in the content tree. <a>Learn more about inherited restrictions</a>"
    }
});
module.exports["archivePagesRestrictionWarningsI18n"] = $e746a1c385e2631b$export$77cf259b67e812fb;

});

parcelRegister("ewt2O", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $b288c1dd11d89e75$export$9b81d39c063708b1 = /*#__PURE__*/ function(DescendantsNoteApplicationOption) {
    DescendantsNoteApplicationOption["ALL"] = "ALL";
    DescendantsNoteApplicationOption["NONE"] = "NONE";
    DescendantsNoteApplicationOption["ROOTS"] = "ROOTS";
    return DescendantsNoteApplicationOption;
}({});
module.exports["DescendantsNoteApplicationOption"] = $b288c1dd11d89e75$export$9b81d39c063708b1;

});

parcelRegister("5edTx", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

const $1b0b7a318544a8db$export$e97fc0d33cef2cc5 = ({ children: children, targetEditions: targetEditions })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return children({
        isFeatureEnabled: targetEditions.includes(edition)
    });
};
module.exports["EditionFeatureGate"] = $1b0b7a318544a8db$export$e97fc0d33cef2cc5;

});

parcelRegister("3pgvV", function(module, exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $27b08439c96aff18$var$isNull(value) {
    return value === null;
}
module.exports = $27b08439c96aff18$var$isNull;

});


//# sourceMappingURL=UnarchivePagesLoader.87fc072f.js.map
